import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { uniqueIdentificationGenerator } from '../../utils/uniqueIdentificationGenerator'

import warningIcon from 'images/warning-icon.svg'
import errorIcon from 'images/error-icon.svg'
import successIcon from 'images/success-icon.svg'

class TextArea extends Component {
  static propTypes = {
    /* The input placeholder */
    placeholder: PropTypes.string,

    /* The text that will be displayed along with the input */
    label: PropTypes.string,

    /* The input name */
    name: PropTypes.string,

    /* The input id */
    id: PropTypes.string,

    /* The text that will be displayed below the input */
    helpText: PropTypes.string,

    /* The text that will be displayed below the input when the input is valid */
    successText: PropTypes.string,

    /* The text that will be displayed below the input when an error is found */
    errorText: PropTypes.string,

    /* The text that will be displayed below the input when an warning need to be displayed */
    warningText: PropTypes.string,

    /* The element classes */
    className: PropTypes.string,

    /* Initial value */
    value: PropTypes.string,

    /* Callback for when the input changes */
    onChange: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.number,
    ]),

    /* Determine if the input is or not required */
    required: PropTypes.bool,

    /* Determine if the input is or not disabled */
    disabled: PropTypes.bool,

    /* Determine if the input is or not readonly */
    readOnly: PropTypes.bool,

    /* Function that will be triggered when the value changes. May return true or false to wheter the new value is or not valid */
    validateValue: PropTypes.func,

    controlled: PropTypes.bool
  }

  state = {
    /* The input value  */
    value: this.props.value || '',

    /* Stores the information of wheter the input is or not valid  */
    isValid: null,
  }

  getClasses() {
    const { disabled, readOnly } = this.props
    const { isValid } = this.state
    return `
            ${disabled ? 'disabled' : ''}
            ${isValid === false ? 'invalid' : ''}
            ${isValid === true ? 'valid' : ''}
            ${readOnly ? 'read-only' : ''}
        `
  }

  onChange(value) {
    const { onChange = () => {}, controlled = false } = this.props

    if(!controlled) {
      this.setState(
        {
          value,
          isValid: this.valueIsValid(value),
        },
   
        onChange(value)
      )

    }

    else {
      onChange(value)
    }
    
  }

  valueIsValid(value) {
    const { required, validateValue } = this.props

    if (validateValue) {
      return validateValue(value)
    }
    return required && value === ''
  }

  textHelperDisplay() {
    const { errorText, warningText, helpText, successText } = this.props
    const { isValid } = this.state

    if (isValid === true) {
      if (successText)
        return ['success', <img key='successIcon' src={successIcon} />, successText]
    } else if (isValid !== false) {
      if (helpText) return ['default', null, helpText]
    } else {
      if (errorText) {
        return ['error', <img key='errorIcon' src={errorIcon} />, errorText]
      }
      if (warningText) {
        return ['warning', <img key='warningIcon' src={warningIcon} />, warningText]
      }
    }
    return ['', null, null]
  }

  render() {
    const { label, name, required, disabled, className, id, placeholder, controlled = false } =
      this.props
    const value = !controlled ? this.state.value : this.props.value

    const customId = id || uniqueIdentificationGenerator('input-text_')
    const customName = name || uniqueIdentificationGenerator('input-text_')
    const classes = this.getClasses()
    const [validationClass, smallIcon, smallText] = this.textHelperDisplay()

    return (
      <>
        <div style={{marginLeft: 0}} className={`text-area-container ${validationClass} ${classes}`}>
          <label>
            {label}
            {required !== true && <i> - opcional</i>}
          </label>
          <textarea
            maxLength={1500}
            id={customId}
            style={{overflowY: "auto"}}
            name={customName}
            disabled={disabled}
            required={required}
            className={className || 'form-control-textarea'}
            onChange={(e) => this.onChange(e.target.value)}
            value={value}
            placeholder={placeholder}
          />
          {smallText && (
            <small className={validationClass}>
              {smallIcon}
              {smallText}
            </small>
          )}
        </div>
      </>
    )
  }
}

export default TextArea
